import { guardRoute } from "../security/permissions.router";
import { session } from "../state/session";

// Minimal shape needed from Router for navigation
type RouterLike = {
  navigate: (path: string, options?: { replace?: boolean }) => void;
};

/**
 * Route guard plugin for @thepassle/app-tools/router
 *
 * Uses the router "before navigation" hook style.
 * The plugin signature matches the Router plugins convention.
 */
export function routeGuardPlugin(router: RouterLike) {
  // Return a function that router will call for each navigation.
  // In @thepassle router, a plugin can return lifecycle hooks.
  return {
    // Runs before navigation is confirmed
    beforeNavigation: async (location: { pathname: string }) => {
      const { member, loading } = session;

      if (loading) {
        // Block navigation while session is resolving
        return false;
      }

      const decision = guardRoute(member, location.pathname);

      if (!decision.allow) {
        router.navigate(decision.redirectTo, { replace: true });
        return false; // cancel the original navigation
      }

      return true; // allow navigation
    },
  };
}
